import React from "react";
import { LeafIcon } from "lucide-react";
import { MetaPixel } from "./components/MetaPixel";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
import { Hero } from "./components/sections/Hero";
import { Mindset } from "./components/sections/Mindset";
import { BeforeAfter } from "./components/sections/BeforeAfter";
import { Volumes } from "./components/sections/Volumes";
import { Resources } from "./components/sections/Resources";
import { Bonuses } from "./components/sections/Bonuses";
import { Offer } from "./components/sections/Offer";
import { Guarantee } from "./components/sections/Guarantee";
import { Author } from "./components/sections/Author";
import { Testimonials } from "./components/sections/Testimonials";
import { Faq } from "./components/sections/Faq";
import { FinalCta } from "./components/sections/FinalCta";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream font-sans text-ink" data-id="element-0" data-mp="23ut97wmn5o7m">
      <MetaPixel data-id="element-1" data-mp="3ij61y35c994p" />
      <Hero data-id="element-2" data-mp="3ijpet5g4t7bv" />
      <main data-id="element-3" data-mp="3ii4s22026sok">
        <Mindset data-id="element-4" data-mp="3mlj6wpc9h30f" />
        <BeforeAfter data-id="element-5" data-mp="3ml17xky7saot" />
        <Volumes data-id="element-6" data-mp="3mk85uxa7a9d0" />
        <Resources data-id="element-7" data-mp="3mjq27fl7ksv2" />
        <Bonuses data-id="element-8" data-mp="3mj6jvxrnc2gi" />
        <Offer data-id="element-9" data-mp="3rcj7q5oi4587" />
        <Guarantee data-id="element-10" data-mp="3rbzmaezn6ypf" />
        <Author data-id="element-11" data-mp="3rdkgg3i1ofmr" />
        <Testimonials data-id="element-12" data-mp="3rd1a7k1rbfok" />
        <Faq data-id="element-13" data-mp="3relwynhtxubv" />
        <FinalCta data-id="element-14" data-mp="5or2zhbcs60" />
      </main>
      <footer className="w-full bg-brand-deep px-5 pb-28 pt-10 text-center text-cream/80" data-id="element-15" data-mp="4ww9qvjiygs">
        <div className="flex items-center justify-center gap-2 text-cream" data-id="element-16" data-mp="2zm4y4lnitf2c">
          <LeafIcon className="h-5 w-5" aria-hidden="true" data-id="element-17" data-mp="33mf623uvifju" />
          <span className="font-display text-lg tracking-[0.12em]" data-id="element-18" data-mp="33ori60dy9voz">THE AROMA LAB™</span>
        </div>
        <p className="mt-2 text-sm" data-id="element-19" data-mp="38nunzn1r85y0">Created by Nancy Uribe</p>
        <p className="mt-1 text-xs text-cream/60" data-id="element-20" data-mp="3dlw542fmdv6u">© 2026 · All Rights Reserved</p>
      </footer>
      <FloatingCta data-id="element-21" data-mp="nuhgse7ce3s6" />
      <PurchasePopup data-id="element-22" data-mp="nv0xjrl9am4m" />
    </div>;
}